import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Input, Button, Space } from 'antd';
import {
  PhoneOutlined, MailOutlined, EnvironmentOutlined,
  FacebookOutlined, InstagramOutlined, YoutubeOutlined,
  SendOutlined, ArrowRightOutlined, SafetyCertificateOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

const Footer = () => {
  const services = [
    { label: 'Hadj & Oumra', to: '/hadj-oumra' },
    { label: 'Location de véhicules', to: '/services/location-vehicules' },
    { label: 'Navette AIBD', to: '/services/navette-aibd' },
    { label: 'Assurance', to: '/services/assurance' },
    { label: 'Conseils', to: '/services/conseils' },
  ];

  const links = [
    { label: 'À propos', to: '/a-propos' },
    { label: 'Galerie', to: '/galerie' },
    { label: 'Actualités', to: '/actualites' },
    { label: 'Demander un devis', to: '/demander-devis' },
    { label: 'Contact', to: '/contact' },
  ];

  return (
    <footer className="ndv-footer">
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        <Row gutter={[{ xs: 20, md: 48 }, { xs: 24, md: 40 }]}>
          <Col xs={24} sm={24} md={6}>
            <div style={{ marginBottom: '18px' }}>
              <img
                src="/img/logo-new-white.png"
                alt="Ndiouroul Voyages"
                style={{ height: '76px', width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
              />
            </div>
            <p style={{ color: '#8ba0b8', fontSize: '13.5px', lineHeight: 1.9, marginBottom: '18px' }}>
              Votre partenaire de confiance pour le Hajj et la Oumra. Agence sénégalaise spécialisée
              dans l'organisation de voyages religieux et de tourisme.
            </p>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.25)',
              borderRadius: '20px', padding: '7px 14px', marginBottom: '22px',
            }}>
              <SafetyCertificateOutlined style={{ color: '#d4af37' }} />
              <span style={{ color: '#d4af37', fontSize: '12px', fontWeight: 500 }}>
                Licence officielle de pèlerinage
              </span>
            </div>
            <Space size={10}>
              {[
                { icon: <FacebookOutlined />, href: '#' },
                { icon: <InstagramOutlined />, href: '#' },
                { icon: <YoutubeOutlined />, href: '#' },
              ].map((social, i) => (
                <a key={i} href={social.href} aria-label="Réseau social" style={{
                  width: '40px', height: '40px', borderRadius: '11px',
                  background: 'rgba(255,255,255,0.07)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  color: '#9fb2c8', fontSize: '16px', border: '1px solid rgba(255,255,255,0.06)',
                }}>
                  {social.icon}
                </a>
              ))}
            </Space>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <h4>Nos Services</h4>
            {services.map((item, i) => (
              <Link key={i} to={item.to}>
                <ArrowRightOutlined style={{ fontSize: '10px', color: 'var(--accent-color)' }} />
                {item.label}
              </Link>
            ))}
          </Col>

          <Col xs={24} sm={12} md={6}>
            <h4>Liens Utiles</h4>
            {links.map((item, i) => (
              <Link key={i} to={item.to}>
                <ArrowRightOutlined style={{ fontSize: '10px', color: 'var(--accent-color)' }} />
                {item.label}
              </Link>
            ))}
            <h4 style={{ marginTop: '30px' }}>Horaires</h4>
            <div style={{ color: '#8ba0b8', fontSize: '13.5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <ClockCircleOutlined style={{ color: 'var(--accent-color)' }} />
              Lundi - Samedi : 8h - 19h
            </div>
          </Col>

          <Col xs={24} sm={24} md={6}>
            <h4>Contact</h4>
            <div style={{ marginBottom: '14px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
              <EnvironmentOutlined style={{ color: 'var(--accent-color)', marginTop: '4px', fontSize: '14px' }} />
              <span style={{ color: '#8ba0b8', fontSize: '13.5px', lineHeight: 1.7 }}>
                Villa 136, Mamelles Aéroport, Dakar, Sénégal
              </span>
            </div>
            {['+221 78 736 27 27', '+221 33 823 29 34', '+221 77 638 62 63'].map((phone, i) => (
              <div key={i} style={{ marginBottom: '9px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <PhoneOutlined style={{ color: 'var(--accent-color)', fontSize: '14px' }} />
                <a href={`tel:${phone.replace(/\s/g, '')}`} style={{ color: '#8ba0b8', padding: 0 }}>
                  {phone}
                </a>
              </div>
            ))}
            <div style={{ marginBottom: '9px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <MailOutlined style={{ color: 'var(--accent-color)', fontSize: '14px' }} />
              <a href="mailto:ndiouroulvoyage2@gmail.com" style={{ color: '#8ba0b8', padding: 0, wordBreak: 'break-all' }}>
                ndiouroulvoyage2@gmail.com
              </a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <MailOutlined style={{ color: 'var(--accent-color)', fontSize: '14px' }} />
              <a href="mailto:info@ndiouroulvoyage.com" style={{ color: '#8ba0b8', padding: 0, wordBreak: 'break-all' }}>
                info@ndiouroulvoyage.com
              </a>
            </div>

            <h4 style={{ marginTop: '28px' }}>Newsletter</h4>
            <div style={{ display: 'flex', overflow: 'hidden', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.12)' }}>
              <Input
                placeholder="Votre email"
                style={{
                  flex: 1, border: 'none', background: 'rgba(255,255,255,0.07)',
                  color: '#fff', height: '46px',
                }}
              />
              <Button
                type="primary"
                icon={<SendOutlined />}
                aria-label="S'abonner à la newsletter"
                style={{
                  width: '52px', height: '46px', borderRadius: 0,
                  background: 'linear-gradient(135deg, #e3c35a, #d4af37)', color: 'var(--primary-ink)',
                  border: 'none', fontSize: '16px',
                }}
              />
            </div>
          </Col>
        </Row>

        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)',
          marginTop: '48px', padding: '22px 0',
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: '10px',
        }}>
          <p style={{ color: '#667c94', fontSize: '13px', margin: 0 }}>
            &copy; {new Date().getFullYear()} Ndiouroul Voyage. Tous droits réservés.
            <span style={{ display: 'block', marginTop: '4px' }}>Made with ❤ by MOUNIR DIGITAL</span>
          </p>
          <p style={{ color: '#667c94', fontSize: '13px', margin: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
            <SafetyCertificateOutlined style={{ color: '#d4af37' }} />
            Agence agréée par l'État — Licence officielle de pèlerinage
          </p>
        </div>
      </div>

      <style>{`
        .ndv-footer .ant-input::placeholder { color: #7a8fa8 !important; }
      `}</style>
    </footer>
  );
};

export default Footer;
